import React from "react";
import "./Components.css";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import red from "@material-ui/core/colors/red";
import green from "@material-ui/core/colors/green";
import grey from "@material-ui/core/colors/grey";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Chip from "@material-ui/core/Chip";
import {
  faPlus,
  faMinus,
  faShoppingBag
} from "@fortawesome/free-solid-svg-icons";

library.add(faPlus);
library.add(faMinus);
library.add(faShoppingBag);
const styles = {
  card: {
    width: "20%"
  },
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto"
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[400]
  }
};
const Item = props => {
  if (props.item) {
    const { id, img, title, description, amount } = props.item;
    const add = props.add;
    const sub = props.sub;
    // return (
    //   <div className="item inline">
    //     <img src={img} alt={title} />
    //     <h3>{title}</h3>
    //     <p>{description}</p>
    //     <div>
    //       <button className="inline" onClick={sub.bind(null, id)}>
    //         -
    //       </button>
    //       <span className="inline">{amount}</span>
    //       <button className="inline" onClick={add.bind(null, id)}>
    //         +
    //       </button>
    //     </div>
    //   </div>
    // );

    return (
      <Card className="inline" style={styles.card}>
        <CardHeader
          avatar={
            <Avatar aria-label="Recipe" style={styles.avatar}>
              <FontAwesomeIcon icon="shopping-bag" />
            </Avatar>
          }
          title={title}
          subheader=""
        />
        <CardMedia image={img} title={title} style={styles.media} />
        <CardContent>
          <Typography component="p">{description}</Typography>
        </CardContent>
        <CardActions disableActionSpacing style={styles.actions}>
          <IconButton
            onClick={sub.bind(null, id)}
            style={{ margin: "10px auto" }}
            aria-label="remove"
          >
            <FontAwesomeIcon icon="minus" />
          </IconButton>
          <Chip
            label={amount}
            style={
              amount > 0
                ? {
                    backgroundColor: green[600],
                    color: "white",
                    margin: "10px auto"
                  }
                : { backgroundColor: grey[200], margin: "10px auto" }
            }
          />
          &nbsp;
          <IconButton
            onClick={add.bind(null, id)}
            aria-label="add"
            style={{ margin: "10px auto" }}
          >
            <FontAwesomeIcon icon="plus" />
          </IconButton>
        </CardActions>
      </Card>
    );
  }
  return <p />;
};

export default Item;
